import type { Permission } from "~/types/auth.type";

export const visitorPermissions: Permission = {
  valve: {
    read: true,
  },
  multisensor: {
    read: true,
  },
  room: {
    read: true,
  },
  floor: {
    read: true,
  },
  planning: {
    read: true,
  },
};
